import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import { message } from "antd";
import { createApiClient } from "apiClient";
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";

interface CustomDropDownProps {
  readonly title: string;
  readonly dropDownValues: string[];
  readonly selectedValue: string;
  readonly setSelectedValue: (flag: any) => void;
}

export const CustomDropDown: React.FC<CustomDropDownProps> = ({
  title,
  dropDownValues,
  selectedValue,
  setSelectedValue
}) => {
  const [openDropDown, setOpenDropDown] = useState(false);
  const [selected, setSelected] = useState<string>(dropDownValues[0] || "");
  const wrapperRef = useRef<HTMLDivElement>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setOpenDropDown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (item: string) => {
    setSelectedValue?.(item);
    setOpenDropDown(false);
  };

  return (
    <DropDownWrapper ref={wrapperRef}>
      <DropDownTitle>{title}</DropDownTitle>
      <DropDownInput>
        <LeftSection>{selectedValue}</LeftSection>
        <RightSection onClick={() => setOpenDropDown(prev => !prev)}>
          {openDropDown ? <CaretUpOutlined /> : <CaretDownOutlined />}
        </RightSection>
      </DropDownInput>

      {openDropDown && (
        <DropDownList>
          {dropDownValues.map(item => (
            <DropDownItem key={item} onMouseDown={() => handleSelect(item)}>
              {item}
            </DropDownItem>
          ))}
        </DropDownList>
      )}
    </DropDownWrapper>
  );
};

// Styled Components

const DropDownWrapper = styled.div`
  position: relative;
  width: fit-content;
  font-family: sans-serif;
`;

const DropDownTitle = styled.div`
  font-weight: 400;
  margin-bottom: 2px;
  margin-left: 4px;
`;

const DropDownInput = styled.div`
  width: 120px;
  height: 35px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  display: flex;
  overflow: hidden;
`;

const LeftSection = styled.div`
  width: 75%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weigth: 400;
`;

const RightSection = styled.div`
  cursor: pointer;
  width: 25%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s ease;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;

  &:hover {
    background-color: #f0f0f0;
  }
`;

const DropDownList = styled.div`
  position: absolute;
  top: 100%;
  width: 100%;
  background-color: white;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  margin-top: 4px;
`;

const DropDownItem = styled.div`
  padding: 8px;
  cursor: pointer;
  text-align: center;

  &:hover {
    background-color: #f5f5f5;
  }
`;
